export default __webpack_public_path__ + "static/multi-currency.url-f74037ccfb9d20990dfbfbe4d0228522.svg";